var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contacts"},[_c('header',{staticClass:"main-header",style:({ backgroundImage: ("url(" + (require('@/assets/img/contacts/header.png')) + ")") })},[_c('h1',[_vm._v(_vm._s(_vm.$t('contacts.title')))])]),_c('Contacts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }